import React, { FC, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { UUID } from 'api/types';

import { actions } from '../slice';

import { EnvironmentWizard } from './EnvironmentWizard';

interface Props {}

export const EditEnvironment: FC<Props> = () => {
  const params = useParams<UUID>();
  const dispatch = useDispatch();

  useEffect(() => {
    if (params?.uuid) {
      dispatch(actions.getEnvironment({ q: { environmentId: params.uuid } }));
    }
  }, [params, dispatch]);

  return <EnvironmentWizard actionType="Update" />;
};
